module.exports = __webpack_public_path__ + "static/media/warning.94a76e53.svg";